// PHRMPC domain enums — added on demand as screens are built.

import { DateTime } from "luxon";

export const FilterOperator = {
  Equals: 0,
  NotEquals: 1,
  Contains: 2,
  NotContains: 3,
  StartsWith: 4,
  EndsWith: 5,
  GreaterThan: 6,
  GreaterThanOrEquals: 7,
  LessThan: 8,
  LessThanOrEquals: 9,
  IsNull: 10,
  IsNotNull: 11,
  In: 12,
  NotIn: 13,
} as const;

export const FilterLogic = {
  And: 0,
  Or: 1,
} as const;

export const DEPLOYMENT_ACTIONS = {
  Save: "SAVE",
  Edit: "EDIT",
  Submit: "SUBMIT",
  ForRevision: "FORREVISION",
  Approve: "APPROVE",
  Cancel: "CANCEL",
} as const;

export interface EnumOption {
  id: number;
  code: string;
  name: string;
}

export const PARTICULAR_OPTIONS: EnumOption[] = [
  "Store Visit / Store Audit",
  "Attendance Checking (Members)",
  "Issuance of Uniforms / IDs",
  "Enrollment of ATM or Paycard /Payroll Forms",
  "Served Notices",
  "Signing of Contracts (Probationary, Regularization & EOC)",
  "Evaluation of Members",
  "Pickup DTR",
  "Refresher or Orientation to members",
  "Signing of ATDs",
  "Signing of clearance",
  "Mobile logs Assistance",
  "Coop Loan Application",
  "Signing of exit clearance",
  "201 Pick UP / Assisting new hires with requirements completion",
  "Disseminating new company policies, memos, and updates to all members",
  "Other Members Concerns",
  "AAP Assistance",
  "Purchase Supplies",
  "Counseling of Members",
].map((name, i) => ({
  id: i + 1,
  code: name
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, ""),
  name,
}));

export const MCP_STATUS_OPTIONS: EnumOption[] = [
  { id: 1, code: "DRAFT", name: "Draft" },
  { id: 2, code: "FOR-APR", name: "For Approval" },
  { id: 3, code: "APPROVED", name: "Approved" },
  { id: 4, code: "FOR-REV", name: "For Revision" },
  { id: 5, code: "CANCELLED", name: "Cancelled" },
];

export const SSCR_STATUS_OPTIONS: EnumOption[] = [
  { id: 1, code: "DRAFT", name: "Draft" },
  { id: 2, code: "FOR_SUPERVISOR_APPROVAL", name: "For Approval" },
  { id: 3, code: "FOR_REVISION", name: "For Revision" },
  { id: 4, code: "APPROVED", name: "Approved" },
  { id: 5, code: "CANCELLED", name: "Cancelled" },
];

export const CONCERN_ISSUE_OPTIONS = [
  "Salary",
  "Service charge",
  "Charges",
  "Total CBU",
  "Mobile Apps Issues",
  "Status of Cases / NODA / NTE",
  "Mandatories Contri/Loans",
  "ML/Palawan Reference",
  "Accident Assistance",
  "Maternity & Sickness Filing status",
  "Last Claims",
  "Vacancies/Plantilla",
  "ATM status",
  "Incentives",
].map((name, i) => ({
  id: i + 1,
  code: name
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, ""),
  name,
}));

const CURRENT_YEAR = new Date().getFullYear();
export const YEARS_OPTIONS: { id: number; code: number; name: string }[] =
  Array.from({ length: CURRENT_YEAR - 1900 + 1 }, (_, i) => {
    const year = CURRENT_YEAR - i;
    return { id: year, code: year, name: year.toString() };
  });

export const MONTHS_OPTIONS = Array.from({ length: 12 }, (_, i) => {
  const month = DateTime.fromObject({ month: i + 1 });
  return { id: i + 1, code: month.toFormat('LLLL').toUpperCase(), name: month.toFormat('LLLL') };
});
